import { createFileRoute } from '@tanstack/react-router';
import { ProviderAddForm } from '@/features/administrator-panel/provider-add/ProviderAddForm.tsx';

export const Route = createFileRoute('/admin/providers/add')({
  head: () => ({ meta: [{ title: 'Provider Add' }] }),
  component: ProviderAddForm,
});
